// Site languages. Hungarian lives at the site root, the others under a URL
// prefix (/en/..., /da/...). The server picks the first language from the
// visitor's country; this module keeps the page, the API and the switcher
// in line with the language of the current URL.

export const LANGUAGES = [
    { code: "hu", name: "Magyar", flag: "/img/flags/hu.svg" },
    { code: "en", name: "English", flag: "/img/flags/gb.svg" },
    { code: "da", name: "Dansk", flag: "/img/flags/dk.svg" }
];

export const ROOT_LOCALE = "hu";
export const FALLBACK_LOCALE = "en";
const COOKIE = "site_lang";
const PREFIXED = LANGUAGES.map(l => l.code).filter(c => c !== ROOT_LOCALE);

export const PREFIX_PATTERN = PREFIXED.join("|");

export function prefixOf(path) {
    const first = String(path || "")
        .replace(/^\/+/, "")
        .split("/")[0];
    return PREFIXED.includes(first) ? first : null;
}

export function stripPrefix(path) {
    const prefix = prefixOf(path);
    if (!prefix) {
        return path || "/";
    }
    return String(path).replace(new RegExp(`^/?${prefix}(?=/|$)`), "") || "/";
}

export function localizedPath(path, locale) {
    const bare = stripPrefix(path);
    if (locale === ROOT_LOCALE) {
        return bare;
    }
    return `/${locale}${bare === "/" ? "" : bare}`;
}

// The language of the page is the language of its URL.
export const currentLocale = prefixOf(window.location.pathname) || ROOT_LOCALE;

function rememberLocale(locale) {
    const maxAge = 60 * 60 * 24 * 365;
    document.cookie = `${COOKIE}=${locale}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

// Browsing a language counts as choosing it, so plain links and later
// visits stay in this language instead of being re-detected by country.
rememberLocale(currentLocale);

export function switchLanguage(locale) {
    if (!LANGUAGES.some(l => l.code === locale)) {
        return;
    }
    rememberLocale(locale);
    const { pathname, search, hash } = window.location;
    // Full reload so every piece of content is fetched in the new language.
    window.location.href = localizedPath(pathname, locale) + search + hash;
}
